var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaceholder = function SvgPlaceholder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 161,
    viewBox: "0 0 188 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 55.0252C48.2816 29.7345 68.7838 9.23242 94.0745 9.23242C119.365 9.23242 139.867 29.7346 139.867 55.0253V129.527C139.867 133.801 136.843 137.494 132.638 138.258C104.689 143.333 85.713 143.523 55.5642 138.223C51.3338 137.479 48.2816 133.775 48.2816 129.479V55.0252Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8628 54.4043C87.8708 59.6983 80.2818 59.3885 77.6488 54.4043",
    stroke: "black",
    strokeWidth: 4.02164,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.378 54.2773C107.386 59.5713 99.7965 59.2616 97.1636 54.2773",
    stroke: "black",
    strokeWidth: 4.02164,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.038 71.6992C102.038 82.0847 85.8616 82.0275 85.8616 71.6992",
    stroke: "black",
    strokeWidth: 2.48874,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4159 64.3855L46.3173 49.9221C46.1385 23.6761 67.2701 2.2546 93.5161 2.07576V2.07576C119.762 1.89693 141.184 23.0285 141.362 49.2745L141.461 63.7379",
    stroke: "black",
    strokeWidth: 3.44374
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.361 50.3245C151.348 48.4226 149.795 46.8914 147.894 46.9043L139.629 46.9606L139.826 75.8874L148.091 75.8311C149.993 75.8181 151.524 74.2658 151.511 72.364L151.361 50.3245Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5646 73.1462C36.5775 75.0481 38.1298 76.5793 40.0317 76.5664L48.2965 76.5101L48.0994 47.5833L39.8346 47.6396C37.9327 47.6526 36.4014 49.2049 36.4144 51.1067L36.5646 73.1462Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0159 68.8984C52.1353 74.5979 53.8779 76.1815 64.9354 75.2167M59.7137 72.9301L64.8778 72.8068L65.0011 77.9709L60.173 77.7418L59.7137 72.9301Z",
    stroke: "black",
    strokeWidth: 2.06625
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3402 134.402C35.3402 129.871 39.2402 126.322 43.7519 126.749L93.6877 131.473C94.2045 131.522 94.7249 131.522 95.2417 131.472L144.7 126.751C149.182 126.323 153.058 129.847 153.058 134.348C153.058 138.256 150.106 141.532 146.22 141.939L95.3072 147.268C94.747 147.327 94.1823 147.328 93.622 147.271L42.2507 142.051C38.3261 141.652 35.3402 138.347 35.3402 134.402Z",
    fill: "#1E88E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.017 149.827L100.015 149.831L97.6896 155.853C96.9986 157.642 95.0288 158.578 93.2052 157.984L39.8389 140.594C37.5957 139.863 36.096 137.749 36.1472 135.39L36.1978 133.061C36.2789 129.327 40.063 126.823 43.5314 128.207L90.5735 146.989C91.2753 147.269 92.0714 146.928 92.352 146.226L94.4442 140.993C95.1901 139.128 97.3159 138.231 99.1728 138.998L100.274 139.453C102.092 140.204 102.973 142.272 102.257 144.103L100.017 149.827Z",
    fill: "#0059AB",
    stroke: "#0059AB",
    strokeWidth: 1.74212
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.024 133.082C152.951 128.728 148.542 125.794 144.497 127.408L96.6324 146.508C96.3772 146.61 96.0878 146.486 95.9857 146.231L93.8915 140.996C92.9655 138.681 90.3279 137.568 88.0234 138.519L86.7773 139.033C84.5198 139.965 83.4244 142.533 84.3146 144.807L86.5545 150.529L88.8788 156.548C89.7371 158.77 92.1846 159.932 94.4492 159.192L148.774 141.441C151.37 140.593 153.109 138.152 153.063 135.423L153.024 133.082Z",
    fill: "#1E88E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.048 156.444L94.4193 158.82C92.0901 159.803 89.4094 158.665 88.4986 156.306L86.3077 150.633L84.0687 144.917C83.177 142.641 84.2748 140.07 86.5356 139.14L88.2802 138.423C90.583 137.475 93.2163 138.588 94.1426 140.899L96.4281 146.602",
    stroke: "#0059AB",
    strokeWidth: 1.74212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3981 138.58C43.1784 129.217 55.6481 118.731 64.2302 87.7806L58.2635 80.1607C48.703 109.394 38.0489 121.381 10.3018 129.345C7.40218 130.178 6.18632 133.684 8.04616 136.059L8.92391 137.18C9.98093 138.53 11.7625 139.095 13.3981 138.58Z",
    fill: "#1E88E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.602 138.332C144.822 128.969 132.352 118.483 123.77 87.5325L129.736 79.9127C139.297 109.146 149.951 121.133 177.698 129.097C180.598 129.93 181.814 133.436 179.954 135.811L179.076 136.932C178.019 138.282 176.237 138.847 174.602 138.332Z",
    fill: "#1E88E5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "placeholder.a5b74c021297331c48af25db1182e4a2.svg";